const homeFeaturedProjectsBullets = new Swiper(".home-featured-projects .swiper--featured-projects-bullets");

const homeFeaturedProjectsSlides = new Swiper(".home-featured-projects .swiper--featured-projects-slides", {
	// Optional parameters
	loop: false,
	slidesPerView: 1,
	lazy: true,
	simulateTouch: false,
	effect: "fade",

	autoplay: {
		delay: 3000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},

	// If we need pagination
	pagination: false,

	// Navigation arrows
	navigation: {
		nextEl: '.home-featured-projects .swiper--featured-projects-bullets .swiper-button-next',
		prevEl: '.home-featured-projects .swiper--featured-projects-bullets .swiper-button-prev',
	},
});

homeFeaturedProjectsSlides.controller.control = homeFeaturedProjectsBullets;
homeFeaturedProjectsBullets.controller.control = homeFeaturedProjectsSlides;

var homeFeaturedProjectsAutoplay = true;

(function ($) {
	// On Dom Ready
	$(function () {
		// Toggle slide play/pause
		$('.home-featured-projects .btn-play-pause').on('click', function (e) {
			e.preventDefault();
			$('.home-featured-projects .btn-play-pause').toggleClass("active");

			if(homeFeaturedProjectsAutoplay) {
				homeFeaturedProjectsBullets.autoplay.stop();
				homeFeaturedProjectsSlides.autoplay.stop();
				homeFeaturedProjectsAutoplay = false;
			}
			else{
				homeFeaturedProjectsBullets.autoplay.start();
				homeFeaturedProjectsSlides.autoplay.start();
				homeFeaturedProjectsAutoplay = true;
			}
		});

		// Switch slides on list hover
		$(".swiper-list-items a.slide-item").hover(function () {
				// over
				homeFeaturedProjectsBullets.autoplay.stop();
				homeFeaturedProjectsSlides.autoplay.stop();
				homeFeaturedProjectsAutoplay = false;
				homeFeaturedProjectsSlides.slideTo($(this).data('slide-id'));
			}, function () {
				// out
				homeFeaturedProjectsBullets.autoplay.start();
				homeFeaturedProjectsSlides.autoplay.start();
				homeFeaturedProjectsAutoplay = true;
			}
		);

		homeFeaturedProjectsSlides.on('slideChange', function () {
			$('.swiper-list-items a.slide-item').removeClass('active');
			$('.swiper-list-items a.slide-item[data-slide-id="' + homeFeaturedProjectsSlides.activeIndex + '"]').addClass('active');
		});

		// remove active class from all items when hover over ".and-more-link"
		$('.home-featured-projects .and-more-link').hover(function () {
			$('.swiper-list-items a.slide-item').removeClass('active');
		});
	});
})(jQuery);
